import { Outlet } from '@tanstack/react-router';
import { useGetConfigByType } from '@r/hooks/use-workspace-config.ts';
import defaultBg from '@r/assets/images/fiddy/default-image.png';

export const PublicLayoutComponent = () => {
  const backgroundUrls = useGetConfigByType('media', 'public-bg', true) ?? [];

  return (
    <div
      className="flex min-h-screen public-bg"
      style={{
        backgroundImage: `url(${
          backgroundUrls.length > 0
            ? backgroundUrls[Math.floor(Math.random() * backgroundUrls.length)]
            : defaultBg
        })`
      }}
    >
      <Outlet />
    </div>
  );
};
